import isMobileApp from './is-mobile-app';

// window.ReactNativeWebView is injected into the browser from
// the react native webview
export default (({
  type,
  data,
  ...extraData
}) => {
  try {
    if (isMobileApp() && window?.ReactNativeWebView?.postMessage) {
      // The transpilation for window?.ReactNativeWebView?.postMessage will make this throw an error if used here
      // "postMessage need to be called on ReactNativeWebView" most probably because of `this` usage.
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type,
        data,
        ...extraData
      }));
    }
  } catch (err) {
    // eslint-disable-next-line
    console.warn(err);
  }
});